export const FETCH_ITEMS = 'fetchItems';
export const SET_ITEMS = 'setItems';
export const SET_COUNT = 'setCount';
export const SET_PAGE = 'setPage';
export const SET_PAGE_COUNT = 'setPageCount';
export const SET_LIMIT = 'setLimit';



// WEBPACK FOOTER //
// ./src/pages/blog/list/consts.ts